import React from 'react'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { ShortcutKbd } from '@/components/ui/shortcut-kbd'
import type { MenuCommand } from '../types/menu-items'

type DesktopCommandItemProps = {
  command: MenuCommand
  closeMenu: () => void
}

/**
 * Desktop dropdown row for a menu command. Selecting it keeps Radix from auto-closing
 * (`preventDefault`), runs the action, then closes the whole menu.
 */
export const DesktopCommandItem: React.FC<DesktopCommandItemProps> = ({ command, closeMenu }) => {
  return (
    <DropdownMenuItem
      disabled={command.disabled}
      onSelect={(e) => {
        e.preventDefault()
        if (command.disabled) return
        command.action?.()
        closeMenu()
      }}
    >
      {command.label}
      {command.shortcutKey && <ShortcutKbd shortcutKey={command.shortcutKey} />}
    </DropdownMenuItem>
  )
}
